import { Product, MainProductType } from './interfaces';

export const isIncompleteDynamicPackage = (product: Product): boolean => {
  if (product.type !== MainProductType.DynamicPackage) return false;

  const isPartial = product.product_data?.isPartialDynamicPackage === true;
  const hasEventContext = product.product_data?.hasEventContext === true;
  const hasEvents = product.subProducts?.some(
    (sp) => sp.type === MainProductType.Event
  );
  const hasHotelOrFlight = product.subProducts?.some(
    (sp) => sp.type === MainProductType.Hotel || sp.type === MainProductType.Flights
  );

  if (isPartial) return true;
  if (hasEventContext && !hasEvents) return true;
  if (hasEvents && !hasHotelOrFlight) return true;

  return false;
};

// Finds an order-product node (top-level product or nested sub-product) by
// its order-product id.
export const findOrderProductNode = (
  nodes: any[] | undefined,
  targetId: number
): any => {
  for (const node of nodes ?? []) {
    if (Number(node?.id) === targetId) return node;
    const found = findOrderProductNode(node?.subProducts, targetId);
    if (found) return found;
  }
  return null;
};

// The totals the cart shows. In attach-to-order "replace" mode the product
// being replaced stays visible but is excluded from the displayed totals (it
// is soft-deleted on save). Shared by the cart footer and the mobile summary
// bars so they can never disagree.
export const getCartDisplayTotals = (
  cart: { products?: any[]; total_price?: any; total_net_price?: any } | null | undefined,
  replacedOrderProductId?: number | string | null
) => {
  const targetId = Number(replacedOrderProductId);
  const replacedNode = targetId
    ? findOrderProductNode(cart?.products, targetId)
    : null;
  const replacedGrossPrice = Number(replacedNode?.total_price) || 0;
  const replacedNetPrice = Number(replacedNode?.total_net_price) || 0;
  return {
    replacedNode,
    displayTotalPrice: (Number(cart?.total_price) || 0) - replacedGrossPrice,
    displayTotalNetPrice:
      (Number(cart?.total_net_price) || 0) - replacedNetPrice,
  };
};
